<template>
  <div id="app" @contextmenu.prevent="">
    <router-view/>
  </div>
  <!--  <div id="app">-->
  <!--    <router-view/>-->
  <!--  </div>-->
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body, div {
  margin: 0;
  padding: 0;
  border: 0;
  user-select: none;
}
</style>
